import * as React from 'react';
import { formatNumber } from '@telerik/kendo-intl';
import * as moment from 'moment';
import DisplayAddress from './DisplayAddress';
import { ReceiptData } from './Accounts/ReceiptsPreview';

type Props = {
    receipt: ReceiptData;
}

export default class Receipt extends React.PureComponent<Props> {

    public render() {
        return <div className="container">
        <h3 className="text-center">Receipt for Childcare Services</h3>
        <div className="row">
            <div className="col-sm-9">
                <img className='invoice-logo' src={this.props.receipt.LogoPath} alt='' />
                <p>
                    {this.props.receipt.FacilityName}
                    <br />
                    <DisplayAddress address={this.props.receipt.FacilityAddress} />
                </p>
            </div>
            <div className="col-sm-3 float-right" style={{ textAlign: 'center' }}>
                <p>
                    <b>RECEIPT NUMBER</b><br />
                    {this.props.receipt.Number}<br />
                    <b>RECEIPT YEAR</b><br />
                    {moment(this.props.receipt.TaxReceiptDate || 0).format('YYYY')}<br />
                    <b>AMOUNT</b><br />
                    {formatNumber(this.props.receipt.Amount, "c")}
                </p>
            </div>
        </div>
        <br />
        <div className="row">
            <div className="col-md-6">
                Received From:<br />
                {this.props.receipt.BillingName}<br />
                <DisplayAddress address={this.props.receipt.BillingAddress} />
                <br />
                <br />
                For Children:<br />
                {this.props.receipt.Children.map((child, index) => {
                    return <React.Fragment key={index}>
                        {child}<br />
                    </React.Fragment>
                })}
            </div>
            <div className="col-md-6 text-right">
                <br />
                <br />
                <br />
                <br />
                <br />
                <hr />
                <span className="text-muted float-right">
                    Authorized Signature<br />
                    {this.props.receipt.TenantName}
                </span>
            </div>
        </div>
        <div style={{ marginBottom: '20px', pageBreakAfter: 'always' }} />
    </div>
    }
}
